export default __webpack_public_path__ + "static/media/abot-heroe-mb.a7b8cbb5.png";